export default [
  {value: "CALL_DATETIME", name: "Date & Time", isNeed: false},
  {value: "CALL_FROM", name: "Mobile Phone", isNeed: false},
  {value: "CALLER_NAME", name: "Caller", isNeed: false},
  {value: "CALLEE_NAME", name: "Callee", isNeed: false},
  {value: "CATEGORY", name: "Category", isNeed: false},
  {value: "REFERRAL_SOURCE", name: "Referral Source", isNeed: false},
  {value: "NEW_CLIENT", name: "New Client", isNeed: false},
  {value: "CONVERSION", name: "Conversion", isNeed: false},
  {value: "APPOINTMENTS", name: "Appointments", isNeed: false},
  {value: "AI_ANALYTICS", name: "AI Analytics", isNeed: false},
  {value: "CUSTOMER_SATISFACTION", name: "Customer Satisfaction", isNeed: false},
  {value: "ISSUED_RESOLVED", name: "Issued Resolved", isNeed: false},
  {value: "CALL_STATUS", name: "Status", isNeed: false},
  {value: "CALL_DURATION", name: "Duration", isNeed: false},
  {value: "KEYWORDS", name: "Keywords", isNeed: false},
  {value: "COMMENT", name: "Comment", isNeed: false},
  {value: "SUMMARY", name: "Summary", isNeed: false},
]
